import React, { useEffect, useState, useCallback, memo, useRef } from "react";
import {
	GoogleMap,
	useLoadScript,
	InfoWindow,
	Marker,
	OverlayView,
} from "@react-google-maps/api";
import LampDataService from "../../apis/lamps-data";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Polyline } from "@react-google-maps/api";

import {
	deviceErrorEventCode,
	deviceStatusCode,
} from "../../constants/constants";
import mapRedImg from "../../assets/images/map-icon-input-red.svg";

import mapGreenImg from "../../assets/images/map-icon-green.svg";

import icPoleLamp0 from "../../assets/images/ico-pole-lamp0.png";
import icPoleLamp1 from "../../assets/images/ico-pole-lamp1.png";
import icPoleLamp2 from "../../assets/images/ico-pole-lamp2.png";
import icPoleLamp3 from "../../assets/images/ico-pole-lamp3.png";
import icPoleLamp4 from "../../assets/images/ico-pole-lamp4.png";

import icPoleLamp0Off from "../../assets/images/ico-pole-lamp0-off.png"
import icPoleLamp1Off from "../../assets/images/ico-pole-lamp1-off.png";
import icPoleLamp2Off from "../../assets/images/ico-pole-lamp2-off.png";
import icPoleLamp3Off from "../../assets/images/ico-pole-lamp3-off.png";
import icPoleLamp4Off from "../../assets/images/ico-pole-lamp-off.png";

import icPoleLamp0On from "../../assets/images/ico-pole-lamp0-on.png";
import icPoleLamp1On from "../../assets/images/ico-pole-lamp1-on.png";
import icPoleLamp2On from "../../assets/images/ico-pole-lamp2-on.png";
import icPoleLamp3On from "../../assets/images/ico-pole-lamp3-on.png";
import icPoleLamp4On from "../../assets/images/ico-pole-lamp4-on.png";

import DeviceDataService from "../../apis/device-data";

import PoleDataService from "../../apis/pole-data";
import "../../styles/dashboard.scss";

import * as dev_constants from '../../constants/dev_constants';
import { checkUserAccess } from "../../apis/auth";

import { updatePoles } from "../../query/pole.query";
import { getSLCLine, updateSLCLine } from "../../query/slc-line.query";
import { NotificationManager } from "react-notifications";
import { GeoPoint } from "firebase/firestore";



const containerStyle = {
	width: "100%",
	height: "300px",
};


const GOOGLE_MAP_CONFIG = {
	//   apiKey: "AIzaSyAuCpOhLsnn5cLRvW3il_f_2Tb6mJ03eEU",
	// apiKey: "AIzaSyAn4guV9udrnZ0WVfxXWEr4ClB16ho2E",
	// apiKey: "AIzaSyA3YwoIVmgjMg0bCROj-ICuDiysP3r3XqE",
	apiKey: "AIzaSyAgpuvCWt4jbFoC7zjgl7MgwZBOg4zafUU",
	center: {
		lat: 10.95069,
		lng: 76.95634,
	},
	zoom: 15,
};


const SlcMap = ({ data = [] }) => {
	console.log((`Lamp map ===>>> ${JSON.stringify(data)}`))
	const history = useHistory();

	const { isLoaded } = useLoadScript({
		id: "google-map-script",
		googleMapsApiKey: `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${GOOGLE_MAP_CONFIG.apiKey}`,
	});

	const mapRef = React.useRef();
	const [map, setMap] = useState(null);
	const [center, setCenter] = useState({
		...GOOGLE_MAP_CONFIG.center,
	});
	const [activeMarker, setActiveMarker] = useState(null);
	// const [activeLamps, setActiveLamps] = useState([]);
	const [activePoles, setActivePoles] = useState([]);
	const [toggleMap, setToggleMap] = useState(true);
	const [dataCount, setDataCount] = useState(0);
	const [showWatts, setShowWatts] = useState(false);
	const [refresh, setRefresh] = useState(false);
	const slcLine = useRef({});
	const contentRef = useRef();
	const [imageUrl, setImageUrl] = useState('');
	const drawFlag = useRef(false);
	const eraseFlag = useRef(false);
	const popupFlag = useRef(true);
	const moveLampFlag = useRef(false);
	const poleWatts = useRef([]);
	const [infoWindowFlag, setInfoWindowFlag] = useState(null);



	// const [poleMarkerPosition, setPoleMarkerPosition] = useState({});
	const poleMarkerPosition = useRef({});
	const [MarkerPosition, setMarkerPosition] = useState({});

	useEffect(async () => {
		console.log("=====> Data dount update");
		if (map != null) {
			console.log("=====> Data dount update map available");
			updateMapBounds(map, data);
			// const bounds = new window.google.maps.LatLngBounds();
			// data.forEach((mItem) => {
			// let lat = 0;
			// let lng = 0;
			// let pole = null;
			// const { loc: { _lat: devLat = 0, _long: devLng = 0 } = {} } = mItem || {};
			// if (mItem.pid != undefined && mItem.pid != null) {
			//   pole = PoleDataService.getInstance().getPole(mItem.pid);
			// }

			// if (pole != null && pole.loc != undefined && pole.loc != null) {
			//   const {
			//     loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
			//   } = pole;
			//   lat = latitudeVal;
			//   lng = longitudeVal;
			// } else {
			//   lat = devLat;
			//   lng = devLng;
			// }
			//   if (lat == 0 && lng == 0) {
			//     return;
			//   }
			//   const position = {
			//     lat,
			//     lng,
			//   };
			//   return bounds.extend(position);
			// });
			// map.fitBounds(bounds);
		} else {
			console.log("=====> Data dount update no map");
		}
	}, [dataCount]);


	useEffect(async () => {
		setTimeout(() => {
			setDataCount((preVal) => {
				return preVal + 1
			});
		}, 1000);
	}, [data]);

	const onMapClick = (e) => {

		const position = {
			lat: e.latLng.lat(),
			lng: e.latLng.lng(),
		};

		drawMap(position);



	}

	const drawMap = (line) => {

		if (drawFlag.current == true) {

			var newItem = {
				"lat": line.lat,
				"lng": line.lng
			};
			//  console.log(newItem);

			var path = slcLine.current?.data?.path;
			if (path != undefined && path != null) {
				// Clone the outer array
				const newOuterArray = [...path];
				// Get the last outer array index
				const lastOuterIndex = newOuterArray.length - 1;
				// Clone the last inner array
				const lastInnerArray = [...newOuterArray[lastOuterIndex]];
				// Append the new item to the last inner array
				lastInnerArray.push(newItem);
				// Update the last inner array in the outer array
				newOuterArray[lastOuterIndex] = lastInnerArray;
				// Return the updated array as the new state
				slcLine.current.data.path = newOuterArray;
			}
			slcLine.current.data.slc_id = data;
			setRefresh((data) => { return !data; });

		}
	}
	const onLoad = useCallback(function callback(mapArg) {
		// const bounds = new window.google.maps.LatLngBounds();
		// data.forEach((mItem) => {
		//   let lat = 0;
		//   let lng = 0;
		//   let pole = null;
		//   const { loc: { _lat: devLat = 0, _long: devLng = 0 } = {} } = mItem || {};
		//   if (mItem.pid != undefined && mItem.pid != null) {
		//     pole = PoleDataService.getInstance().getPole(mItem.pid);
		//   }

		//   if (pole != null && pole.loc != undefined && pole.loc != null) {
		//     const {
		//       loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
		//     } = pole;
		//     lat = latitudeVal;
		//     lng = longitudeVal;
		//   } else {
		//     lat = devLat;
		//     lng = devLng;
		//   }
		//   const position = {
		//     lat,
		//     lng,
		//   };
		//   // debugger;
		//   return bounds.extend(position);
		// });
		// mapArg.fitBounds(bounds);
		updateMapBounds(mapArg, data);
		setMap(mapArg);

	}, []);

	const updateMapBounds = (googleMap, item) => {
		const bounds = new window.google.maps.LatLngBounds();
		let lat = 0;
		let lng = 0;
		let pole = item;
		if (pole != null && pole.loc != undefined && pole.loc != null) {
			const { loc: { latitude: latitudeVal = 0, longitude: longitudeVal = 0 } = {} } = pole;
			lat = latitudeVal;
			lng = longitudeVal;
		} else {
			const response = PoleDataService.getInstance().getPole(pole?.pid);
			if (response && response.loc) {
				const { loc: { latitude: latitudeVal = 0, longitude: longitudeVal = 0 } } = response;
				lat = latitudeVal;
				lng = longitudeVal;
			} else {
 				lat = 0;
				lng = 0;
			}
		}


		const position = { lat, lng };

		// Only extend the bounds if latitude and longitude are valid (non-zero)
		if (lat !== 0 || lng !== 0) {
			bounds.extend(position);
		}
		console.log(`Bounds --->> ${JSON.stringify(bounds)}`)
		// Fit the map to the bounds
		googleMap.fitBounds(bounds);
	};


	const updateMapBoundsByPoles = (googleMap, poles) => {
		const bounds = new window.google.maps.LatLngBounds();
		poles.forEach((pole) => {
			let lat = 0;
			let lng = 0;

			if (pole != null && pole.loc != undefined && pole.loc != null) {
				const {
					loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
				} = pole;
				lat = latitudeVal;
				lng = longitudeVal;
			}
			const position = {
				lat,
				lng,
			};
			if (lat == 0 && lng == 0) {
				return;
			}
			return bounds.extend(position);
		});
		googleMap.fitBounds(bounds);
	}

	const onZoomChanged = () => {
		if (map != null) {
			console.log(`Zoom changed ${map.getZoom()}`);
			// if (activeMarker != null && activeMarker != "") {
			// 	downloadMap(activeMarker, activeLamps, map.getZoom().toString());
			// }
		}
	};

	const onUnmount = React.useCallback(function callback(map) {
		setMap(null);
	}, []);

	const getDeviceStatus = (devId) => {
		const mapItem = data[devId];

		if (mapItem != null && mapItem.dev_st == dev_constants.DeviceStatusOn) {
			return deviceStatusCode[1];
		} else {
			return deviceStatusCode[2];
		}
	};

	const getMapImage = (ccmsItem) => {
		const { err_cnt = 0, errors = [], dev_st = 0, dev_id = "" } = ccmsItem || {};
		const mapItem = data[dev_id];

		if (mapItem != null && mapItem.dev_st == dev_constants.DeviceStatusOn) {
			return mapGreenImg;
		} else {
			return mapRedImg;
		}
	};


	// const getLampImage = (lamp) => {
	// 	const { dev_st: statusCode = 0, wt: wt = 0, lgt: lgt = false } = lamp || {};
	// 	if (showWatts) {
	// 		if (wt > 0 && wt <= 20) {
	// 			// return mapStreetLightPink;
	// 			return lgt ? mapStreetLightTriangleShaded : mapStreetLightTriangle;
	// 		} else if (wt <= 70) {
	// 			// return mapStreetLightOrange;
	// 			return lgt ? mapStreetLightCircleShaded : mapStreetLightCircle;
	// 		} else if (wt > 70 /*120 /*wt <= 120*/) {
	// 			// return mapStreetLightGreen;
	// 			return lgt ? mapStreetLightDiamondShaded : mapStreetLightDiamond;
	// 		} else {
	// 			// return mapStreetLightBlue
	// 			return lgt ? mapStreetLightSquareShaded : mapStreetLightSquare;
	// 		}

	// 	} else {
	// 		if (statusCode === 1) {
	// 			return mapStreetLightOn;
	// 		} else {
	// 			return mapStreetLightOff;
	// 		}
	// 	}
	// };

	const getPoleImage = (pole) => {
		// debugger;
		var poleImage = icPoleLamp1;
		const { slc_id: slc_id, nfix: nfix = 0, is_slc: is_slc = false, dmy: dmy = false } = pole || {};
		if (is_slc) {
			var status = DeviceDataService.getInstance().isDeviceIdOn(slc_id);
			if (status == true) {
				/// SLC is on
				if (nfix === 0) {
					poleImage = icPoleLamp0On;///Green pole no lamp
				} else if (nfix === 1) {
					poleImage = icPoleLamp1On;///Green pole 1 lamp
				} else if (nfix === 2) {
					poleImage = icPoleLamp2On;///Green pole 2 lamp
				} else if (nfix === 3) {
					poleImage = icPoleLamp3On;///Green pole 3 lamp
				} else if (nfix > 3) {
					poleImage = icPoleLamp4On;///Green pole 4 lamp
				}
			} else {
				/// SLC is off
				if (nfix === 0) {
					poleImage = icPoleLamp0Off;///Red pole no lamp
				} else if (nfix === 1) {
					poleImage = icPoleLamp1Off;///Red pole 1 lamp
				} else if (nfix === 2) {
					poleImage = icPoleLamp2Off;///Red pole 2 lamp
				} else if (nfix === 3) {
					poleImage = icPoleLamp3Off;///Red pole 3 lamp
				} else if (nfix > 3) {
					poleImage = icPoleLamp4Off;///Red pole 4 lamp
				}
			}
		} else {
			if (nfix === 0) {
				poleImage = icPoleLamp0;///pole no lamp
			} else if (nfix === 1) {
				poleImage = icPoleLamp1;///pole 1 lamp
			} else if (nfix === 2) {
				poleImage = icPoleLamp2;///pole 2 lamp
			} else if (nfix === 3) {
				poleImage = icPoleLamp3;///pole 3 lamp
			} else if (nfix > 3) {
				poleImage = icPoleLamp4;///pole 4 lamp
			}
		}
		return poleImage;
		// if (showWatts) {
		// 	if (wt > 0 && wt <= 20) {
		// 		// return mapStreetLightPink;
		// 		return lgt ? mapStreetLightTriangleShaded : mapStreetLightTriangle;
		// 	} else if (wt <= 70) {
		// 		// return mapStreetLightOrange;
		// 		return lgt ? mapStreetLightCircleShaded : mapStreetLightCircle;
		// 	} else if (wt > 70 /*120 /*wt <= 120*/) {
		// 		// return mapStreetLightGreen;
		// 		return lgt ? mapStreetLightDiamondShaded : mapStreetLightDiamond;
		// 	} else {
		// 		// return mapStreetLightBlue
		// 		return lgt ? mapStreetLightSquareShaded : mapStreetLightSquare;
		// 	}

		// } else {
		// 	if (statusCode === 1) {
		// 		return mapStreetLightOn;
		// 	} else {
		// 		return mapStreetLightOff;
		// 	}
		// }
	};

	const [mapCenter, setMapCenter] = useState(center);
	const getLatLng = (rowData) => {
		let degreeSymbol = "\u00B0";
		let result = "";
		let latitude = 0;
		let longitude = 0;
		let pole = null;
		if (rowData?.pid != undefined && rowData?.pid != null) {
			pole = PoleDataService.getInstance().getPole(rowData?.pid);
		}

		if (pole != null && pole?.loc != undefined && pole?.loc != null) {
			const {
				loc: { latitude: latitudeVal = 0, longitude: longitudeVal = 0 } = {}
			} = pole;
			latitude = latitudeVal;
			longitude = longitudeVal;
		} else if (rowData?.lloc != undefined) {
			const {
				lloc: { latitude: latitudeVal = 0, longitude: longitudeVal = 0 } = {}
			} = rowData;
			latitude = latitudeVal;
			longitude = longitudeVal;
		} else {
			const {
				loc: { latitude: latitudeVal = 0, longitude: longitudeVal = 0 } = {}
			} = rowData;
			latitude = latitudeVal;
			longitude = longitudeVal;
		}


		if ((latitude === undefined | "") || (longitude === undefined | "")) {
			return "N/A"
		}
		if (latitude > 0) {
			result = `${latitude.toFixed(4)}${degreeSymbol}N`;
		} else {
			result = `${latitude.toFixed(4)}${degreeSymbol}S`;
		}
		if (longitude > 0) {
			result = `[${result}, ${longitude.toFixed(4)}${degreeSymbol}E]`;
		} else {
			result = `[${result}, ${longitude.toFixed(4)}${degreeSymbol}W]`;
		}
		return result;

	}
	const handleCenterChanged = () => {
		// const googleMmap = mapRef.current;
		if (map) {
			const center = map.getCenter();
			setMapCenter({
				lat: center.lat(),
				lng: center.lng(),
			});
		}
	};

	const overlayViewRef = React.useRef(null);

	const overlayViewContent = (
		<div
			style={{
				background: 'white',
				border: '1px solid #ccc',
				padding: 10,
				borderRadius: 5,
			}}
		>
			Overlay Content
		</div>
	);

	const overlayPosition = {
		lat: mapCenter.lat + 0.01, // Adjust latitude to position vertically
		lng: mapCenter.lng + 0.01, // Adjust longitude to position horizontally
	};

	const getPixelPositionOffset = (offsetWidth, offsetHeight, labelAnchor) => {
		return {
			x: offsetWidth + labelAnchor.x,
			y: offsetHeight + labelAnchor.y,
		};
	};

	// const downloadMap = async (slcId, lamps, zoomVal = "21") => {
	// 	// debugger;
	// 	let center = "";//"Eiffel Tower,Paris";
	// 	let mapType = "roadmap";
	// 	let visible = "";//48.85849004093204,2.294502763863771|48.84335670044386,2.360956251923224|48.85320764866506, 2.3428376983684824";
	// 	let scale = "1";
	// 	let zoom = zoomVal;
	// 	let size = "640x640";
	// 	let path = `color:0x0000ff|weight:5`;//|48.85849004093204,2.294502763863771|48.84335670044386,2.360956251923224|48.85320764866506, 2.3428376983684824`;
	// 	let markersString = "";
	// 	let clat = 0;
	// 	let clng = 0;
	// 	//     `color:red|label:E|48.85849004093204,2.294502763863771
	// 	//     color:blue|label:11|48.84335670044386,2.360956251923224
	// 	//     color:green|label:4|48.85320764866506, 2.3428376983684824`
	// 	// ;
	// 	const slcDevice = data.find((element) => element.uid == slcId);
	// 	if (slcDevice != null) {
	// 		let lat = 0;
	// 		let lng = 0;
	// 		let pole = null;

	// 		const {
	// 			loc: { _lat: devLat = 0, _long: devLng = 0 } = {},
	// 			uid: ccmsNumber = null,
	// 			dev_st = 0,
	// 			err_cnt = 0,
	// 			errors = [],
	// 		} = slcDevice || {};

	// 		if (slcDevice.pid != undefined && slcDevice.pid != null) {
	// 			pole = PoleDataService.getInstance().getPole(slcDevice.pid);
	// 		}

	// 		if (pole != null && pole.loc != undefined && pole.loc != null) {
	// 			const {
	// 				loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
	// 			} = pole;
	// 			lat = latitudeVal;
	// 			lng = longitudeVal;
	// 		} else {

	// 			lat = devLat;
	// 			lng = devLng;
	// 		}
	// 		const position = {
	// 			lat,
	// 			lng,
	// 		};
	// 		if (lat != 0 && lng != 0) {
	// 			center = `${lat},${lng}`;
	// 			markersString = `color:red|label:S|${lat},${lng}`
	// 			visible = `${lat},${lng}`;

	// 			clat += lat;
	// 			clng += lng;
	// 		}
	// 	}

	// 	lamps.sort((a, b) => {
	// 		return a.lnum - b.lnum;
	// 	});

	// 	lamps.map((item, i) => {
	// 		const {
	// 			dev_id: ccmsNumber = null,
	// 			ilm_id: ilm_id = null,
	// 			lnum: lnum = 0,
	// 			dev_st = 0,
	// 			err_cnt = 0,
	// 			errors = [],
	// 			wt: wt = 0,
	// 		} = item || {};
	// 		let latitude = 0;
	// 		let longitude = 0;
	// 		let pole = null;
	// 		let poleNum = 0;
	// 		if (item.pid != undefined && item.pid != null) {
	// 			pole = PoleDataService.getInstance().getPole(item.pid);
	// 		}

	// 		if (pole != null && pole.loc != undefined && pole.loc != null) {
	// 			const {
	// 				pnum: pnum = 0,
	// 				loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
	// 			} = pole;
	// 			poleNum = pnum;
	// 			latitude = latitudeVal;
	// 			longitude = longitudeVal;
	// 		} else if (item.lloc != undefined | null) {
	// 			const {
	// 				lloc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
	// 			} = item;
	// 			latitude = latitudeVal;
	// 			longitude = longitudeVal;
	// 		} else {
	// 			const {
	// 				loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
	// 			} = item;
	// 			latitude = latitudeVal;
	// 			longitude = longitudeVal;
	// 		}

	// 		if ((latitude === undefined | "") || (longitude === undefined | "")) {
	// 			// return (null);
	// 		}
	// 		// const position = {
	// 		//   lat:latitude,
	// 		//   lng:longitude,
	// 		// };

	// 		// var label = `P${poleNum} / L${lnum}`;
	// 		console.log(`===> Lamp ${ccmsNumber}, [${latitude},${longitude}]`);

	// 		markersString = `${markersString}\ncolor:green|label:L|${latitude},${longitude}`;
	// 		visible = `${visible}|${latitude},${longitude}`;
	// 		path = `${path}|${latitude},${longitude}`;

	// 		clat += latitude;
	// 		clng += longitude;
	// 	});
	// 	// const [center, setCenter] = useState("Eiffel Tower,Paris");
	// 	//   const [mapType, setMapType] = useState("roadmap");
	// 	//   const [visible, setVisible] = useState("48.85849004093204,2.294502763863771|48.84335670044386,2.360956251923224|48.85320764866506, 2.3428376983684824");
	// 	//   const [scale, setScale] = useState("2");
	// 	//   const [zoom, setZoom] = useState("8");
	// 	//   const [size, setSize] = useState("640x640");
	// 	//   const [path, setPath] = useState(`color:0x0000ff|weight:5|48.85849004093204,2.294502763863771|48.84335670044386,2.360956251923224|48.85320764866506, 2.3428376983684824`);
	// 	//   const [markersString, setMarkersString] = useState(
	// 	//       `color:red|label:E|48.85849004093204,2.294502763863771
	// 	//       color:blue|label:11|48.84335670044386,2.360956251923224
	// 	//       color:green|label:4|48.85320764866506, 2.3428376983684824`
	// 	//   );

	// 	clat /= (lamps.length + 1);
	// 	clng /= (lamps.length + 1);

	// 	console.log(`Center ${center} -> ${clat},${clng}`);

	// 	center = `${clat},${clng}`;

	// 	const staticImageURL = generateStaticMapURL({
	// 		center,
	// 		mapType,
	// 		zoom,
	// 		size,
	// 		scale,
	// 		path,
	// 		visible,
	// 		markers: markersString
	// 			.split("\n")
	// 			.map(marker => marker.trim())
	// 			.filter(marker => marker.length > 0)
	// 	});

	// 	try {
	// 		const response = await axios.get(staticImageURL, {
	// 			responseType: 'arraybuffer',
	// 		});
	// 		const base64 = Buffer.from(response.data, 'binary').toString('base64');
	// 		const base64Image = `data:image/jpeg;base64,${base64}`;
	// 		setImageUrl(base64Image);
	// 	} catch (error) {
	// 		console.error('Error fetching the image:', error);
	// 	}
	// }

	// const onClickDownloadPDF = async () => {

	// 	let slcDetail = "";
	// 	let lamp20w = 0;
	// 	let lamp70w = 0;
	// 	let lamp120w = 0;
	// 	let lamp0w = 0;
	// 	const slcDevice = data.find((element) => element.uid == activeMarker);
	// 	if (slcDevice != null) {
	// 		let lat = 0;
	// 		let lng = 0;
	// 		let pole = null;
	// 		let addr = "";
	// 		let latitude = 0;
	// 		let longitude = 0;
	// 		let degreeSymbol = "\u00B0";
	// 		let result = "";

	// 		const {
	// 			loc: { _lat: devLat = 0, _long: devLng = 0 } = {},
	// 			lloc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {},
	// 			uid: ccmsNumber = null,
	// 			dev_id: dev_id = "",
	// 			pid: pid = null,
	// 			dev_st = 0,
	// 			err_cnt = 0,
	// 			errors = [],
	// 			ph_cnt: phaseCode = 0,
	// 			zn: zone = "",
	// 			wd: ward = "",
	// 			dmy: dummyPoles = 0,
	// 			tpoles: totalPoles = 0,
	// 			nfix: totalLamps = 0,
	// 			addr: address = "",
	// 			kw: kw = 0
	// 		} = slcDevice || {};

	// 		if (pid != undefined && pid != null) {
	// 			pole = PoleDataService.getInstance().getPole(pid);
	// 		}

	// 		if (pole != null && pole.addr != undefined && pole.addr != null) {
	// 			addr = pole.addr;
	// 		} else if (address != undefined | null | "") {
	// 			addr = address;
	// 		}

	// 		if (pole != null && pole.loc != undefined && pole.loc != null) {
	// 			const {
	// 				loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
	// 			} = pole;
	// 			latitude = latitudeVal;
	// 			longitude = longitudeVal;
	// 		} else if (latitudeVal != 0 && longitudeVal != 0) {
	// 			latitude = latitudeVal;
	// 			longitude = longitudeVal;
	// 		} else {
	// 			latitude = devLat;
	// 			longitude = devLng;
	// 		}
	// 		if ((latitude === undefined | "") || (longitude === undefined | "")) {
	// 			// return "N/A"
	// 		}
	// 		if (latitude > 0) {
	// 			result = `${latitude}${degreeSymbol}N`;
	// 		} else {
	// 			result = `${latitude}${degreeSymbol}S`;
	// 		}
	// 		if (longitude > 0) {
	// 			result = `[${result}, ${longitude}${degreeSymbol}E]`;
	// 		} else {
	// 			result = `[${result}, ${longitude}${degreeSymbol}W]`;
	// 		}

	// 		slcDetail += `${dev_id} : ${devicePhaseCode[phaseCode]}\n\n`;
	// 		slcDetail += `Zone-${zone}, Ward-${ward}, ${addr}\n\n`;
	// 		slcDetail += `Geo Location: ${result}\n\n`;
	// 		slcDetail += `Total Poles: ${totalPoles}, Dummy Poles: ${dummyPoles}\n\n`;
	// 		slcDetail += `Total Lamps: ${totalLamps}\n\n`;
	// 		slcDetail += `Total KW: ${(kw)}\n\n`;
	// 	}

	// 	activeLamps.map((item, i) => {
	// 		const {
	// 			wt: wt = 0
	// 		} = item || {};

	// 		if (wt > 0 && wt <= 20) {
	// 			// return mapStreetLightPink;
	// 			// return lgt ? mapStreetLightTriangleShaded : mapStreetLightTriangle;
	// 			lamp20w = lamp20w + 1;
	// 		} else if (wt <= 70) {
	// 			// return mapStreetLightOrange;
	// 			// return lgt ? mapStreetLightCircleShaded : mapStreetLightCircle;
	// 			lamp70w = lamp70w + 1;
	// 		} else if (wt > 70 /*120 /*wt <= 120*/) {
	// 			// return mapStreetLightGreen;
	// 			// return lgt ? mapStreetLightDiamondShaded : mapStreetLightDiamond;
	// 			lamp120w = lamp120w + 1;
	// 		} else {
	// 			// return mapStreetLightBlue
	// 			// return lgt ? mapStreetLightSquareShaded : mapStreetLightSquare;
	// 			lamp0w = lamp0w + 1;
	// 		}
	// 	});

	// 	slcDetail += `20w- ${lamp20w}, 70w- ${lamp70w}, 120w- ${lamp120w}, old LED- ${lamp0w}`;
	// 	// SC1TAC10015: Single/Three Phase, Zone-1, Ward-17, Near School
	// 	// Geo Location: 10.11,17.53
	// 	// Total Poles: 10, Dummy Poles: 2
	// 	// Total Lamps: 20
	// 	// Total KW: 0.40 (wt/1000)
	// 	// 20w-10, 40W-6 with corrsponding images for each watts
	// 	// pdf.save(`SLC_${ccmsNumber}.pdf`);

	// 	// debugger;
	// 	const input = contentRef.current;
	// 	html2canvas(input)
	// 		.then((canvas) => {
	// 			const imgData = canvas.toDataURL('image/png');
	// 			const pdf = new jsPDF('p', 'mm', 'a4');
	// 			const imgProps = pdf.getImageProperties(imgData);
	// 			const pdfWidth = pdf.internal.pageSize.getWidth();
	// 			const pdfHeight = pdf.internal.pageSize.getHeight() * 0.3;
	// 			// const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
	// 			console.log(`Page size pdfWidth=${pdfWidth} | imgWidth=${imgProps.width} | imgHeight=${imgProps.height}`);
	// 			console.log(`Page size pdfWidth=${pdf.internal.pageSize.getWidth()} | pdfHeight=${pdf.internal.pageSize.getHeight()}`);
	// 			console.log(`Page size Output pdfWidth=${pdfWidth} | pdfHeight=${pdfHeight}`);

	// 			var xPos = pdfWidth / 4;
	// 			var yPos = 20;

	// 			var title = `${getHeaderDetail("city")} CITY MUNICIPAL CORPORATION`;
	// 			pdf.text(pdfWidth * 0.2, 10, title);

	// 			pdf.addImage(imgData, 'PNG', xPos, yPos, pdfWidth * 0.4, pdfHeight);
	// 			// pdf.addPage('a6','l');
	// 			pdf.text(20, yPos + pdfHeight + 20, slcDetail);
	// 			pdf.save(`SLC_${activeMarker}.pdf`);
	// 		})
	// 		.catch((error) => {
	// 			console.error('Error generating PDF:', error);
	// 		});
	// };

	//Get user Info

	return isLoaded ? (
		<div className="dash-map-wrapper">
			<div style={{ position: 'absolute', left: '-1000px' }} >
				<div style={{ position: 'relative' }} ref={contentRef} id="imgMapRef">
					<img src={imageUrl} />
				</div>
			</div>
			<div className={`dash-map ${!toggleMap && "hide"}`}  >
				<GoogleMap
					setOp
					ref={mapRef}
					mapContainerStyle={containerStyle}
					defaultZoom={10}
					// center={GOOGLE_MAP_CONFIG.center}
					// center={center}
					// zoom={zoom}
					onZoomChanged={onZoomChanged}
					onLoad={onLoad}
					onUnmount={onUnmount}
					onClick={onMapClick}
					onCenterChanged={handleCenterChanged}
					options={{
						disableDefaultUI: false,
						styles: [
							{
								featureType: 'poi',
								elementType: 'labels',
								stylers: [{ visibility: 'off' }]
							}
						]
					}}
					yesIWantToUseGoogleMapApiInternals
				>
					{/* poliline */}
					{slcLine.current?.data?.path?.map((arrItem, i) => {
						return (<Polyline
							onClick={(e) => {
								if (eraseFlag.current == true) {

									const selectedOuterArray = [...slcLine.current.data.path];

									selectedOuterArray.splice(i, 1);

									slcLine.current.data.path = [...selectedOuterArray];
									setRefresh((data) => { return !data; });
									// setPath(prevPath => {

									// 	const selectedOuterArray = [...prevPath];

									// 	selectedOuterArray.splice(i, 1);

									// 	return [...selectedOuterArray];
									// });
								}
							}}
							path={arrItem}
							options={{
								strokeColor: '#000000',
								strokeOpacity: 1.0,
								strokeWeight: 2.5,
							}}
						/>);
					})
					}
					{/* Add custom view here */}
					{/* <div
				style={{
				position: 'absolute',
				top: '10px',
				right: '70px',
				transform: 'translate(-50%, -50%)',
				backgroundColor: 'white',
				padding: '10px',
				borderRadius: '2px',
				boxShadow: '0px 0px 10px rgba(0,0,0,0.3)',
				zIndex: '2'
				}}
				>
				Custom View Over Map
				</div> */}
					{/* <OverlayView
					position={overlayPosition}
					mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
					getPixelPositionOffset={(width, height) => ({
						x: -width + 20, // 20px from right
					y: 20,          // 20px from top
					})}
					>
					<div ref={overlayViewRef}>
					{overlayViewContent}
					</div>
					</OverlayView> */}
					{/* SLC */}
					{/* {activeMarker === null && (() => {
						const item = data;

						let lat = 0;
						let lng = 0;
						let pole = null;

						const {
							uid: ccmsNumber = null,
							dev_id: devId,
							wd: ward,
							zn: zone,
							dev_st = 0,
							err_cnt = 0,
							errors = [],
						} = item || {};

						if (item.pid != undefined && item.pid != null) {
							pole = PoleDataService.getInstance().getPole(item.pid);
						}

						if (pole != null && pole.loc != undefined && pole.loc != null) {
							const {
								loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
							} = pole;
							lat = latitudeVal;
							lng = longitudeVal;
						}

						const position = { lat, lng };

						if (lat === 0 || lng === 0) {
							return null;
						}

						return (
							<Marker
								key={ccmsNumber}
								position={position}
								icon={{
									url: getMapImage(item),  // Set marker icon based on device status
									scaledSize: new window.google.maps.Size(30, 45),  // Icon size
								}}
								onClick={() => {
									if (popupFlag.current) {
										popupFlag.current = false;
										popUpMenu(map, devId, errors, ward, zone, ccmsNumber);
										handleActiveMarker(ccmsNumber);
										setCenter(position);
									}
								}}
							/>
						);
					})()} */}



					{/* poles */}
					{(() => {
						const pole = data;
						const {
							uid = "",
							pid = "",
							slc_id = "",
							zn: zone = '',
							addr: location = '',
							nfix: totalLamps = '',
							pnum: pnum = 0,
							is_slc: is_slc = 0,
							nfix: nfix = 0,
							wd: ward,
							loc: { latitude: latitudeVal = 0, longitude: longitudeVal = 0 } = {}
						} = pole;

						let poleNum = pnum;
						let latitude = latitudeVal;
						let longitude = longitudeVal;
 
						if (latitude === undefined || latitude === "" || latitude === 0 || longitude === undefined || longitude === "" || longitude === 0) {
							const response = PoleDataService.getInstance().getPole(pole?.pid);

							if (response && response.loc) {
								const { loc: { latitude: latitudeVal = 0, longitude: longitudeVal = 0 } } = response;
								latitude = latitudeVal;
								longitude = longitudeVal;
							} else {
 								latitude = 0;
								longitude = 0;
							}
						}

						const m_pos = poleMarkerPosition.current[pid];
						if (m_pos !== undefined) {
							latitude = m_pos.lat;
							longitude = m_pos.lng;
						}
						const position = { lat: latitude, lng: longitude };
						if (!pid) {
							return null;
						}

						const lamps = LampDataService.getInstance().getLampsWattsByPid(pole['pid']).deviceList;
						let wattsObj = {};

						lamps.forEach((lamp) => {
							wattsObj[lamp] = (wattsObj[lamp] || 0) + 1;
						});

						let wattsStr = Object.keys(wattsObj).map(key => `${key}x${wattsObj[key]}`).join(',');

						let label = `${poleNum}/${wattsStr}`;
						if (!wattsStr) {
							label = `${poleNum}`;
						}

						return (
							<Marker
								key={pid}
								position={position}
								draggable={moveLampFlag.current}
								onDragEnd={(event) => {
									poleMarkerPosition.current[pid] = {
										lat: event.latLng.lat(),
										lng: event.latLng.lng(),
									};
								}}
								icon={{
									url: getPoleImage(pole),
									scaledSize: new window.google.maps.Size(30, 30),
								}}
								onClick={() => {
									poleWatts.current = wattsStr;
									setInfoWindowFlag(uid);
									if (drawFlag.current) {
										drawMap(position);
									}
								}}
							>
								<OverlayView
									key="mwl"
									position={position}
									mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
								>
									<div style={{
										background: `#203254`,
										padding: `3px 8px 3px 3px`,
										fontSize: '12px',
										color: `white`,
										borderRadius: '4px',
									}}>
										<text
											style={{
												background: `#203254`,
												padding: `3px 3px 3px 3px`,
												fontSize: '12px',
												color: `white`,
												borderRadius: '4px',
											}}
										>
											{label}
										</text>
									</div>
								</OverlayView>

								{infoWindowFlag === uid && (
									<div>
										<InfoWindow
											position={position}
											onCloseClick={() => { setInfoWindowFlag(""); }}
										>
											<div style={{ fontSize: '12px' }}>
												<div>Ward: {ward}</div>
												<div>Zone: {zone}</div>
												<div>Location: {location}</div>
												<div>GPS Location: {getLatLng(pole)}</div>
												<div>Total lamps: {nfix}</div>
												{poleWatts.current && <div>Pole watts: {poleWatts.current}</div>}
											</div>
										</InfoWindow>
									</div>
								)}
							</Marker>
						);
					})()}


					{/* Lamp */}
					{/* {activeLamps.map((item, i) => {
									const {
									dev_id: ccmsNumber = null,
									ilm_id: ilm_id = null,
									lnum: lnum = 0,
									dev_st = 0,
									err_cnt = 0,
									errors = [],
									} = item || {};
									let latitude = 0;
									let longitude = 0;
									let pole = null;
									let poleNum = 0;
									if (item.pid != undefined && item.pid != null) {
									pole = PoleDataService.getInstance().getPole(item.pid);
									}
									
									if (pole != null && pole.loc != undefined && pole.loc != null) {
									const {
									pnum: pnum = 0,
									loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
									} = pole;
									poleNum = pnum;
									latitude = latitudeVal;
									longitude = longitudeVal;
									} else if (item.lloc != undefined | null) {
									const {
									lloc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
									} = item;
									latitude = latitudeVal;
									longitude = longitudeVal;
									} else {
									const {
									loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
									} = item;
									latitude = latitudeVal;
									longitude = longitudeVal;
									}
									
									if ((latitude === undefined | "") || (longitude === undefined | "")) {
									return (null);
									}
									//console.log(JSON.stringify(LampMarkerPosition));
									var m_pos = LampMarkerPosition[ccmsNumber];
									if(m_pos != undefined ){
									latitude = m_pos.lat;
									longitude = m_pos.lng;
									}
									const position = {
									lat: latitude,
									lng: longitude,
									};
									// 			if(markerPosition.current != null){
									
									//   position = {lat : markerPosition.current.latLng.lat(),lng : markerPosition.current.latLng.lng()};	 
									// 			}
									
									var label = `P${poleNum} / L${lnum}`;
									console.log(`===> Lamp ${ccmsNumber}, [${latitude},${longitude}]`);
									return (
									<Marker
									key={ccmsNumber}
									position={position}
									draggable={moveLampFlag.current}
									onDragEnd={(event) => {
										setLampMarkerPosition((current) => {
											return {
									...current,
									[ccmsNumber]:{
									lat: event.latLng.lat(),
									lng: event.latLng.lng(),
									},}
									});
									}}
									// label={label}
									icon={{
									// url: redBulbImg,
									url: getLampImage(item),
									scaledSize: new window.google.maps.Size(30, 30),
									}}
									onClick={() => {alert(JSON.stringify(position)) }}>
									
									<OverlayView
									key='mwl'
									position={position}
									mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
									getPixelPositionOffset={(x, y) => getPixelPositionOffset(x, y, { x: -40, y: -40 })}>
									<div
									style={{
									background: `#203254`,
									padding: `7px 12px`,
									fontSize: '11px',
									color: `white`,
									borderRadius: '4px',
									}}
									>
									{label}
									<div>
									{ilm_id ?? ""}
									</div>
									</div>
									</OverlayView>
									{/* <InfoWindow
									position={position}
									// onCloseClick={() => resetActiveMarker()}
									>
									<div>
									<div>
									<strong>UID:</strong> {ccmsNumber}
									</div>
									{/* <div>
									<strong>Status:</strong> {getDeviceStatus(ccmsNumber)}
									</div> * /}
									</div>
									</InfoWindow> * /}
									</Marker>
									);
									})} */}

				</GoogleMap>
				{/* Add custom view here */}
				{/* <div
										style={{
										position: 'absolute',
										top: '10px',
										right: '70px',
										transform: 'translate(-50%, -50%)',
										backgroundColor: 'white',
										padding: '10px',
										borderRadius: '2px',
										boxShadow: '0px 0px 10px rgba(0,0,0,0.3)',
										zIndex: '200'
										}}
										>
										Custom View Over Map outside
										</div> */}
			</div>
		</div>
	) : (
		<></>
	);
};

export default memo(SlcMap);